import React, { useEffect, useRef } from 'react';

const ClientCarousel = () => {
  const scrollRef = useRef(null);

  const clients = [
    'https://img1.wsimg.com/isteam/ip/a27d2dc3-82db-4815-b271-215705ee1c2c/6.jpg/:/rs=h:100,cg:true,m',
    'https://img1.wsimg.com/isteam/ip/a27d2dc3-82db-4815-b271-215705ee1c2c/Medybizz%20Pharma.jpg/:/cr=t:0%25,l:0%25,w:100%25,h:100%25/rs=h:100,cg:true',
    'https://img1.wsimg.com/isteam/ip/a27d2dc3-82db-4815-b271-215705ee1c2c/Medybizz%20Pharma%20(1).jpg/:/cr=t:0%25,l:0%25,w:100%25,h:100%25/rs=h:100,cg:true',
    'https://img1.wsimg.com/isteam/ip/a27d2dc3-82db-4815-b271-215705ee1c2c/1.jpg/:/cr=t:0%25,l:0%25,w:100%25,h:100%25/rs=h:100,cg:true',
    'https://img1.wsimg.com/isteam/ip/a27d2dc3-82db-4815-b271-215705ee1c2c/Vindya%20Logo.jpg/:/cr=t:0%25,l:0%25,w:100%25,h:100%25/rs=h:100,cg:true',

    // New Clients
    'https://slice.bank.in/press-kits/slice-logo-4x.png',
    'https://www.hungerbox.ai/wp-content/themes/jan2025/images/new-logo-purple.svg',
    'https://www.houzbay.com/assets/images/logo/Houzbay-logo.png',
    'https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcTxw9uje-99Qn27pwmMoukVpbJ-KKjSuANrhQ&s'
  ];

  // Duplicate clients for seamless loop
  const allClients = [...clients, ...clients];

  useEffect(() => {
    const scrollContainer = scrollRef.current;
    if (!scrollContainer) return;

    let scrollPosition = 0;
    const scrollSpeed = 1;

    const scroll = () => {
      scrollPosition += scrollSpeed;

      if (scrollPosition >= scrollContainer.scrollWidth / 2) {
        scrollPosition = 0;
      }

      scrollContainer.scrollLeft = scrollPosition;
    };

    const interval = setInterval(scroll, 30);

    return () => clearInterval(interval);
  }, []);

  return (
    <div className="bg-gray-50 py-12">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <h2 className="text-3xl font-bold text-center mb-8 text-gray-900">
          Our Clients
        </h2>

        <div className="overflow-hidden w-full relative">
          <div
            ref={scrollRef}
            className="flex gap-12 w-full hide-scrollbar"
            style={{
              overflowX: 'scroll',
              overflowY: 'hidden',
              scrollBehavior: 'auto',
            }}
          >
            {allClients.map((client, index) => (
              <div
                key={index}
                className="flex-shrink-0 flex items-center justify-center"
              >
                <img
                  src={client}
                  alt={`Client ${index + 1}`}
                  className="max-h-20 max-w-[140px] object-contain hover:scale-110 transition-transform duration-300"
                />
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default ClientCarousel;